<template>
    <div v-if="store">
        <h1>Objekt i {{ store.name }}</h1>

        <p>
            <router-link :to="`/store/${store.id}/sales_item/new`" class="button">Nytt objekt</router-link>
        </p>

        <section>
            <h2>Objekt</h2>

            <SalesItemList :sales-items="salesItems" :store="store" v-if="hasFetchedSalesItems"/>
            <div v-else>Laddar...</div>
        </section>

        <section>
            <h2>Ordrar</h2>

            <p v-if="isMergeLoading">
                Sparar...
            </p>
            <p v-else>
                <button @click.prevent="toggleOrderMerge()">
                    {{ (isOrderMerging ? 'Avbryt ihopslagning' : 'Slå ihop ordrar') }}
                </button>
            </p>

            <div v-if="hasFetchedOrders">
                <MergeOrderList v-if="isOrderMerging" :orders="orders" @mergeSubmit="submitOrderMerge"/>
                <OrderList v-else :orders="orders" :store="store"/>
            </div>
            <div v-else>Laddar...</div>
        </section>
    </div>
    <p v-else class="app-loader">
        Laddar...
    </p>
</template>

<script>
import { mapState } from 'vuex'
import SalesItemList from '../components/SalesItemList.vue'
import OrderList from '../components/OrderList.vue'
import MergeOrderList from '../components/MergeOrderList.vue'

export default {
    name: 'store',
    components: {
        SalesItemList,
        OrderList,
        MergeOrderList
    },
    data: function () {
        return {
            storeId: null,
            isOrderMerging: false,
            isMergeLoading: false
        }
    },
    computed: {
        store() {
            return this.$store.getters['traderaStores/getById'](this.storeId);
        },
        hasFetchedSalesItems() {
            return this.$store.getters['salesItems/hasFetchedForId'](this.storeId);
        },
        ...mapState('salesItems', {
            salesItems: state => state.items
        }),
        hasFetchedOrders() {
            return this.$store.getters['traderaOrders/hasFetchedForId'](this.storeId);
        },
        ...mapState('traderaOrders', {
            orders: state => state.orders
        })
    },
    methods: {
        fetchData() {
            this.$store.dispatch('traderaStores/getAll');
            this.$store.dispatch('salesItems/getAll', this.storeId);
            this.$store.dispatch('traderaOrders/getAll', {
                storeId: this.storeId,
                filterArchived: false
            });
        },
        toggleOrderMerge() {
            this.isOrderMerging = !this.isOrderMerging;
        },
        submitOrderMerge(suborders) {
            this.isOrderMerging = false;
            this.isMergeLoading = true;
            this.$store.dispatch('traderaOrders/merge', suborders)
                .then(() => {
                    this.isMergeLoading = false;
                })
                .catch(() => {
                    this.isMergeLoading = false;
                })
            ;
        }
    },
    created() {
        this.storeId = parseInt(this.$route.params.id, 10);
        this.fetchData();
    },
    watch: {
        '$route'(to) {
            this.storeId = parseInt(to.params.id, 10);
            this.fetchData();
        }
    }
}
</script>
